import { LIFECYCLE_CURRENT_STATE } from './lifecycle.constants';

export const initialState = {
  currentState: '',
};

export default (state = initialState, { type, ...data }) => {
  switch (type) {
    case LIFECYCLE_CURRENT_STATE: {
      return {
        ...state,
        currentState: data.currentState,
      };
    }
    default: {
      return state;
    }
  }
};
